if (!customElements.get('announcement-bar')) {
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.detailBtns = document.querySelectorAll('.js-announcement-details');
      this.aggregateModal = document.querySelector('#announcement-modal-aggregate');
      this.parent = this.closest('.shopify-section');
      this.resizeObserver = null;
      this.mutationObserver = null;
    }

    connectedCallback() {
      this.updateHeight();
      this.initObservers();

      if (this.aggregateModal) {
        this.querySelector('.announcement-modal-aggregate__opener')?.classList.remove('hidden');
      }

      this.initDetailButtons();
      this.initLoyaltyDropdown();
    }

    disconnectedCallback() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
      if (this.mutationObserver) {
        this.mutationObserver.disconnect();
        this.mutationObserver = null;
      }
    }

    initLoyaltyDropdown() {
      const trigger = this.querySelector('[data-loyalty-dropdown-trigger]');
      const dropdown = this.querySelector('#announcement-loyalty-dropdown');

      if (!trigger || !dropdown) {
        return;
      }

      trigger.addEventListener('click', event => {
        const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', String(!isExpanded));
        dropdown.classList.toggle('is-open');
        event.stopPropagation();
      });

      document.addEventListener('click', event => {
        if (!trigger.contains(event.target) && !dropdown.contains(event.target)) {
          trigger.setAttribute('aria-expanded', 'false');
          dropdown.classList.remove('is-open');
        }
      });

      document.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          trigger.setAttribute('aria-expanded', 'false');
          dropdown.classList.remove('is-open');
        }
      });
    }

    initDetailButtons() {
      this.detailBtns.forEach(button => {
        button.addEventListener('click', event => {
          event.preventDefault();
          const connectedOpener = button.dataset.detailsModal;
          if (connectedOpener) {
            const modalOpener = this.querySelector(`modal-opener[data-modal='${connectedOpener}'] button`);
            if (modalOpener) {
              if (this.aggregateModal?.hasAttribute('open')) {
                this.aggregateModal.hide();
              }
              modalOpener.click();
            }
          }
        });
      });
    }

    updateHeight() {
      if (!this.parent) return;
      const contentHeight = this.getBoundingClientRect().height;

      // Get computed padding from the section wrapper
      const parentStyles = getComputedStyle(this.parent);
      const paddingTop = parseFloat(parentStyles.paddingTop) || 0;
      const paddingBottom = parseFloat(parentStyles.paddingBottom) || 0;

      // Total height = content + section padding
      const totalHeight = contentHeight + paddingTop + paddingBottom;

      document.body.style.setProperty('--announcement-bar-height', `${totalHeight}px`);
    }

    initObservers() {
      // Observe this element (announcement-bar) for size changes
      if (!this.resizeObserver) {
        this.resizeObserver = new ResizeObserver(() => {
          this.updateHeight();
        });
        this.resizeObserver.observe(this);
      }

      // Observe for content changes (DOM mutations)
      if (!this.mutationObserver) {
        this.mutationObserver = new MutationObserver(() => {
          this.updateHeight();
        });
        this.mutationObserver.observe(this, {
          childList: true,
          subtree: true,
          characterData: true
        });
      }
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);
}
